"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoggingService = /** @class */ (function () {
    function LoggingService() {
    }
    LoggingService.prototype.warnUnityContentRemoveNotAvailable = function (additionalDetials) {
        this.warn("Your version of Unity does not support unloading the WebGL Player.", "This preverts ReactUnityWebGL from unmounting this component properly.", "Please consider updating to Unity 2019.1 or newer, or reload the page", "to free the WebGL Player from the memory. See the follow link for more details:", "https://github.com/elraccoone/react-unity-webgl/issues/22", additionalDetials);
    };
    LoggingService.prototype.errorUnityLoaderNotFound = function (additionalDetials) {
        this.error("Unable to use the Unity Loader, please make sure you've imported", "the Unity Loader the correct way. You might have entered an incorrect", "path to the UnityLoader.js. The path is not relative to your bundle,", "but to your index html file. See the follow link for more details: ", "https://github.com/elraccoone/react-unity-webgl/issues/31", additionalDetials);
    };
    LoggingService.prototype.warn = function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        console.warn(messages.filter(function (_) { return typeof _ !== "undefined"; }).join(" "));
    };
    LoggingService.prototype.error = function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        console.error(messages.filter(function (_) { return typeof _ !== "undefined"; }).join(" "));
    };
    return LoggingService;
}());
exports.loggingService = new LoggingService();
//# sourceMappingURL=LoggingService.js.map